/* In the future we should use QENV lib to manage this kind of build profiles, right now just uncomment relevent env section. */

//LOCAL  
/*
export const apiUrl = "http://localhost:8000/stepglobal/v1";
export const xAPIKey = "rFF59UovdI7x3ZmIs4GPi4kBLIyG7lOT6NltWQa9";
export const reportUrl = "http://localhost:9080/";
*/

//QA
// export const apiUrl = "http://qa-ipv4.smartedriver.com:8000/stepglobal/v1";
// export const xAPIKey = "rFF59UovdI7x3ZmIs4GPi4kBLIyG7lOT6NltWQa9";
// export const reportUrl = "http://qa-ipv4.smartedriver.com:9080/";

//PROD

// export const apiUrl = "https://ewd2.smartedriver.com";
// export const xAPIKey = "rFF59UovdI7x3ZmIs4GPi4kBLIyG7lOT6NltWQa9";
// export const reportUrl = "http://report.smartedriver.com/";

// DEV

export const apiUrl = "http://devserver.smartedriver.com:9080/stepglobal/v1";
export const xAPIKey = "rFF59UovdI7x3ZmIs4GPi4kBLIyG7lOT6NltWQa9";
export const reportUrl = "http://devserver.smartedriver.com:8000";



//COMMON
export const supportUrl = "http://support.smartedriver.com";
